(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koszula1-komentarze-fb"] && !Shopify.designMode) return;
  try {
    
  if (!window.k1fbArrowsInit) {
    window.k1fbArrowsInit = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-k1fb-dir]');
      if (!btn) return;
      var section = btn.closest('.k1fb');
      if (!section) return;
      var track = section.querySelector('.k1fb__track');
      if (!track) return;
      var dir = parseInt(btn.getAttribute('data-k1fb-dir'), 10) || 1;
      track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koszula1-opinie"] && !Shopify.designMode) return;
  try {
    
  if (!window.k1opInit) {
    window.k1opInit = true;

    var k1opClose = function () {
      var boxes = document.querySelectorAll('.k1op__lb');
      for (var i = 0; i < boxes.length; i++) {
        boxes[i].hidden = true;
        var im = boxes[i].querySelector('img');
        if (im) im.removeAttribute('src');
      }
      document.documentElement.style.overflow = '';
    };

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-k1op-full]');
      if (trigger) {
        var sec = trigger.closest('.k1op');
        if (!sec) return;
        var lb = sec.querySelector('.k1op__lb');
        if (!lb) return;
        var img = lb.querySelector('img');
        img.src = trigger.getAttribute('data-k1op-full');
        img.alt = trigger.getAttribute('data-k1op-alt') || '';
        lb.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        return;
      }
      if (e.target.closest('.k1op__lb')) {
        k1opClose();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') k1opClose();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["majty-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initGallery(root){
    if(root.dataset.majtyGalleryReady) return;
    root.dataset.majtyGalleryReady = '1';
    var slides = root.querySelectorAll('.majty-gallery__slide');
    var thumbs = root.querySelectorAll('.majty-gallery__thumb');
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        var i = t.getAttribute('data-index');
        slides.forEach(function(s){ s.classList.toggle('is-active', s.getAttribute('data-index')===i); });
        thumbs.forEach(function(x){ var a = x===t; x.classList.toggle('is-active', a); x.setAttribute('aria-selected', a?'true':'false'); });
      });
    });
  }

  function root(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function openDrawer(){
    var drawer = document.querySelector('cart-drawer');
    if(!drawer){ window.location.href = root() + 'cart'; return; }
    try{
      if(typeof drawer.open === 'function'){ drawer.open(); }
      else { drawer.classList.add('animate','active'); document.body.classList.add('overflow-hidden'); }
    }catch(e){ drawer.classList.add('animate','active'); document.body.classList.add('overflow-hidden'); }
  }

  function refreshDrawer(){
    var wrap = document.getElementById('shopify-section-cart-drawer');
    return fetch(root() + '?section_id=cart-drawer', {headers:{'Accept':'text/html'}})
      .then(function(r){ return r.text(); })
      .then(function(html){
        if(wrap){ wrap.innerHTML = html; }
        // odśwież licznik koszyka (best-effort)
        return fetch(root() + '?section_id=cart-icon-bubble').then(function(r){return r.text();}).then(function(h){
          var bubble = document.getElementById('shopify-section-cart-icon-bubble');
          if(bubble){ bubble.innerHTML = h; }
        }).catch(function(){});
      }).catch(function(){});
  }

  function initAtc(form){
    if(form.dataset.majtyAtcReady) return;
    form.dataset.majtyAtcReady = '1';
    var btn = form.querySelector('button[type="submit"]');
    var err = form.querySelector('[data-majty-atc-err]');
    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(err){ err.hidden = true; err.textContent=''; }
      if(btn){ btn.classList.add('is-loading'); }
      var data = new FormData(form);
      fetch(form.getAttribute('action'), {
        method:'POST',
        headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body: data
      })
      .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, body:j}; }); })
      .then(function(res){
        if(!res.ok){
          if(err){ err.hidden=false; err.textContent = (res.body && res.body.description) || 'Nie udało się dodać do koszyka.'; }
          return;
        }
        return refreshDrawer().then(openDrawer);
      })
      .catch(function(){
        if(err){ err.hidden=false; err.textContent='Wystąpił błąd sieci. Spróbuj ponownie.'; }
      })
      .finally(function(){ if(btn){ btn.classList.remove('is-loading'); } });
    });
  }

  function initSizeModal(scope){
    var root = scope || document;
    var modal = root.querySelector('[data-majty-size-modal]');
    if(!modal) return;
    root.querySelectorAll('[data-majty-size-open]').forEach(function(btn){
      if(btn.dataset.majtySizeReady) return; btn.dataset.majtySizeReady='1';
      btn.addEventListener('click', function(){ modal.hidden=false; document.body.classList.add('overflow-hidden'); });
    });
    if(!modal.dataset.majtySizeReady){
      modal.dataset.majtySizeReady='1';
      var closeModal=function(){ modal.hidden=true; document.body.classList.remove('overflow-hidden'); };
      modal.querySelectorAll('[data-majty-size-close]').forEach(function(c){ c.addEventListener('click', closeModal); });
      document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !modal.hidden) closeModal(); });
    }
  }

  function initAll(scope){
    (scope||document).querySelectorAll('[data-majty-gallery]').forEach(initGallery);
    (scope||document).querySelectorAll('[data-majty-atc]').forEach(initAtc);
    initSizeModal(scope);
  }

  if(document.readyState!=='loading'){ initAll(); }
  else { document.addEventListener('DOMContentLoaded', function(){ initAll(); }); }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["majty-science"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.majtyTabsReady) return; root.dataset.majtyTabsReady='1';
    var tabs=root.querySelectorAll('.majty-sci__tab');
    var panels=root.querySelectorAll('.majty-sci__panel');
    tabs.forEach(function(t){ t.addEventListener('click', function(){
      var i=t.getAttribute('data-tab');
      tabs.forEach(function(x){var a=x===t;x.classList.toggle('is-active',a);x.setAttribute('aria-selected',a?'true':'false');});
      panels.forEach(function(p){p.classList.toggle('is-active',p.getAttribute('data-panel')===i);});
    }); });
  }
  function all(s){(s||document).querySelectorAll('[data-majty-tabs]').forEach(init);}
  if(document.readyState!=='loading'){all();}else{document.addEventListener('DOMContentLoaded',function(){all();});}
  document.addEventListener('shopify:section:load',function(e){all(e.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
